import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { RecordTitle, RecordTitleSet } from '@app/models/record.model';
import { SettingSelectors } from '@app/store/setting/setting.selectors';
import { Select } from '@ngxs/store';
import { Observable, Subject } from 'rxjs';

@Component({
  selector: 'app-record-select',
  templateUrl: './record-select.component.html',
  styleUrls: ['./record-select.component.scss'],
})
export class RecordSelectComponent implements OnInit, OnDestroy {
  @Output() selectedChange = new EventEmitter<RecordTitle[]>();
  @Output() onCloseChange = new EventEmitter<void>();
  @Select(SettingSelectors.titleSetList) titleList$!: Observable<RecordTitleSet[]>;
  titleSetList!: RecordTitleSet[];
  form!: FormGroup;
  onDestroy$!: Subject<void>;
  source$!: Observable<any>;
  constructor(private fb: FormBuilder) {
    this.onDestroy$ = new Subject();
  }
  ngOnDestroy(): void {
    this.onDestroy$.next();
  }

  ngOnInit(): void {

    this.titleList$.subscribe((titleSetList) => {
      this.titleSetList = titleSetList;
      this.formCreate(titleSetList);
    })
  }

  formCreate(list: RecordTitleSet[]) {
    this.form = this.fb.group({
      titleSetList: this.fb.array(
        list.map((titleSet) =>
          this.fb.array(titleSet.titles.map(() => null))
        )
      ),
    });
  }

  get titleSetListForm() {
    return this.form.get('titleSetList') as FormArray;
  }

  getForm(index: number) {
    return this.titleSetListForm.at(index) as FormArray;
  }

  onSubmit(): void {
    const records = this.titleSetList.map((titleSet, i) => {
      const list = titleSet.titles.filter(
        (_, j) => !!this.titleSetListForm.value[i][j]
      );
      return list.map((item) => ({ ...item, titles: undefined }));
    });

    this.selectedChange.emit(records.flat());
  }
}
